// Product data organized by category
export const CATEGORIES_PRODUCTS = {
  'step-brackets': {
    description:
      'Strong and reliable clamps designed for secure pipe support on walls and ceilings, offering easy installation and long-lasting performance for plumbing and electrical applications.',
    products: [
      {
        id: 1,
        name: 'STEP BRACKETS CLAMPS',
        slug: 'step-brackets-clamps',
        image: '/img/products/step-brackets-clamps.png',
        appImage: '/img/products/step-brackets-clamps-app.png',
        description:
          'A step clamp is designed to hold multiple pipes of different sizes together in a single clamp, securely fixing them to walls or structures .It can be installed horizontally or vertically, offering flexible pipe arrangement options.',
        material: 'GI & PC',
        thickness: '2mm',
        height: '2.5"',
        size: '4" - 36"',
      },
      {
        id: 2,
        name: 'MINI STEP CLAMP',
        slug: 'mini-step-clamp',
        image: '/img/products/mini-step-clamp.png',
        appImage: '/img/products/mini-step-clamp-app.png',
        description:
          'It is a compact version of the step clamp, designed to hold two or more small-diameter pipes neatly in one unit.It is ideal for tight spaces or where lightweight pipe support is needed, such as in residential plumbing, electrical conduits,',
        material: 'GI & PC',
        size: '1/2" - 4"',
      },
      {
        id: 3,
        name: 'SS STEP BRACKET CLAMP',
        slug: 'ss-step-bracket-clamp',
        image: '/img/products/ss-step-bracket-clamp.png',
        appImage: '/img/products/ss-step-bracket-clamp-app.jpg', 
        description:
          'A stainless steel step clamp is a rust-free, durable clamp used to secure multiple pipes together. Made from high-grade stainless steel, it offers long-lasting strength, even in harsh or wet environments.',
        material: 'SS202 & SS304',
        size: '4" - 36"',
      },
      {
        id: 4,
        name: 'VERTICAL SUPPORT',
        slug: 'vertical-support',
        image: '/img/products/vertical-support.png',
        appImage: '/img/products/vertical-support-app.png',
        description:
          'Vertical supports are used to hold and stabilize structures or installations such as Unistrut channels, pipes, and cable trays in a vertical position. They transfer load safely to the base or ceiling, ensuring proper alignment, weight distribution, and structural strength in building installations.',
        material: 'Galvanized Steel',
      },
    ],
  },

  'pipe-clamps': {
    description:
      'Precision-engineered pipe clamps that provide firm grip, vibration control, and dependable support for plumbing, HVAC, and fire-fighting systems.',
    products: [
      {
        id: 5,
        name: 'U SADDLE CLAMPS',
        slug: 'u-saddle-clamps',
        image: '/img/products/u-saddle-clamps.png',
        appImage: '/img/products/u-saddle-clamps-app.png',
        description:
          'Supporting heavy piping, mounting electrical conduit, and securing cables and providing stability',
        material: 'PVC Gold, UPVC/CPVC',
        thickness: '1.6mm',
        height: '19mm',
        size: '1/2" - 4"',
        quantity: '100 nos/packet',
      },
      {
        id: 6,
        name: 'SS PVC / CPVC / UPVC CLAMPS',
        slug: 'ss-pvc-cpvc-upvc-clamps',
        image: '/img/products/ss-pvc-cpvc-upvc-clamps.png',
        appImage: '/img/products/ss-pvc-cpvc-upvc-clamps-app.png',
        description:
          'Securing and supporting pipes to a surface in plumbing, electrical, and industrial applications',
        material: 'SS202 & SS304',
        size: '1/2" - 4"',
      },
      {
        id: 7,
        name: 'NAIL CLAMP',
        slug: 'nail-clamp',
        image: '/img/products/nail-clamp.png',
        appImage: '/img/products/nail-clamp-app.png',
        description:
          'Nail clamp is a metal fitting used to fix pipes securely to walls. It holds the pipe in place and is fastened using a nail to prevent movement or sagging. Commonly used in plumbing and electrical work for neat and safe pipe installations',
        material: 'Galvanized Iron',
        size: '3/4" - 4"',
      },
      {
        id: 8,
        name: 'WALL CLAMP',
        slug: 'wall-clamp',
        image: '/img/products/wall-clamp.png',
        appImage: '/img/products/wall-clamp-app.png',
        description:
          'A wall clamp is a sturdy pipe holder, usually with bolts and nuts, used to fix heavy pipes or rods firmly to walls. It allows for adjustable and secure fastening, often used where strong support is needed.',
        material: 'Galvanized Steel',
        size: '1/2" - 4"',
      },
      {
        id: 29,
        name: 'SWR CLAMP',
        slug: 'swr-clamp',
        image: '/img/products/swr-clamp.png',
        appImage: '/img/products/swr-clamp-app.png',
        description:
          'Used in plumbing to provide secure support and stability to SWR pipes, which carry soil, waste, and rainwater',
        material: 'Galvanized Iron',
        size: '3/4" - 4"',
      },
      {
        id: 30,
        name: 'HOSE CLIP GOLD',
        slug: 'hose-clip-gold',
        image: '/img/products/hose-clip-gold.png',
        appImage: '/img/products/hose-clip-gold-app.png', 
        description:
          'A Gold hose clip is a metal clamp, often with a gold-colored finish, used to secure hoses firmly onto fittings or pipes. Used in automotive, plumbing, and industrial applications where durability and corrosion resistance are important.',
        material: 'Carbon Steel / Stainless Steel',
        finish: 'Golden Zinc Plated',
      },
      {
        id: 31,
        name: 'HOSE CLIP HDPE',
        slug: 'hose-clip-hdpe',
        image: '/img/products/hose-clip-hdpe.png',
        appImage: '/img/products/hose-clip-hdpe-app.png',
        description:
          'To create a leak-proof and secure connection between a hose and a fitting or tube. Commonly used in water supply, irrigation, and industrial piping where HDPE pipes are involved.',
        material: 'Stainless Steel / Galvanized Steel',
      },
      {
        id: 32,
        name: 'ELECTRICAL SADDLE',
        slug: 'electrical-saddle',
        image: '/img/products/electrical-saddle.png',
        appImage: '/img/products/electrical-saddle-app.png',
        description:
          'Used in conduit wiring installations to support cable runs, organize communication cables, secure flat busbars in panels, and mount lighting fixtures',
        material: 'Galvanized Iron',
        size: '5/8", 3/4", 1"',
        finish: 'Zinc Plated',
      },
      {
        id: 33,
        name: 'WATERLINE G.I',
        slug: 'waterline-gi',
        image: '/img/products/waterline-gi.png',
        appImage: '/img/products/waterline-gi-app.png',
        description:
          'Used for supporting and securing pipes, preventing sagging, and providing stability for plumbing, construction, and industrial applications',
        material: 'Galvanized Iron (G.I)',
        size: '1/2" - 1 1/2"',
        quantity: '120 nos/packet',
      },
    ],
  },

  'pipe-hangers': {
    description:
      'Durable pipe hangers designed to suspend pipes safely and neatly, ensuring proper alignment, load distribution, and long service life',
    products: [
      {
        id: 9,
        name: 'STAINLESS STEEL U BOLT',
        slug: 'stainless-steel-u-bolt',
        image: '/img/products/stainless-steel-u-bolt.png',
        appImage: '/img/products/stainless-steel-u-bolt-app.jpg', 
        description:
          'Securing pipes & pipe hangers, beams, support brackets, and structural components in buildings, bridges, towers, and roadways',
        material: 'SS202 & SS304',
        size: '3/4" - 4"',
      },
      {
        id: 10,
        name: 'RUBBER LINED SPLIT CLAMP',
        slug: 'rubber-lined-split-clamp',
        image: '/img/products/rubber-lined-split-clamp.png',
        appImage: '/img/products/rubber-lined-split-clamp-app.png',
        description:
          'Used to securely support, suspend, and secure various types of pipework and conduits in HVAC, industrial, plumbing, and fire protection systems by mounting to walls, ceilings, or floors',
        material: 'Galvanized Steel with EPDM Rubber',
        size: '1/2" - 6"',
        finish: 'Zinc Plated',
      },
      {
        id: 11,
        name: 'UNIVERSAL VCLAMP',
        slug: 'universal-vclamp',
        image: '/img/products/universal-vclamp.png',
        appImage: '/img/products/universal-vclamp-app.jpg', 
        description:
          'A universal clamp is used to hang and support pipes from the ceiling or beams. It keeps the pipe fixed in place and is commonly used in plumbing, HVAC, and fire systems. This helps in safe and neat pipe installation above the ground.',
        material: 'Galvanized Steel',
        size: '1" - 6"',
        finish: 'Zinc Plated',
      },
      {
        id: 12,
        name: 'CLEVIS HANGER',
        slug: 'clevis-hanger',
        image: '/img/products/clevis-hanger.png',
        appImage: '/img/products/clevis-hanger-app.png',
        description:
          'Used to suspend pipes and conduits in residential, commercial, and industrial settings, including plumbing, HVAC, and fire protection systems.',
        material: 'Galvanized Steel',
        finish: 'Zinc Plated',
      },
      {
        id: 34,
        name: 'UNISTRUT CLAMP',
        slug: 'unistrut-clamp',
        image: '/img/products/unistrut-clamp.png',
        appImage: '/img/products/unistrut-clamp-app.png',
        description:
          'Permanent or adjustable support of conduit, pipes, cable trays, and ducts, especially in industrial and commercial environments like construction, warehouses, and mechanical installations',
        material: 'Galvanized Steel',
        finish: 'Zinc Plated',
      },
    ],
  },

  'channel-series': {
    description:
      'High-strength slotted channels and accessories that form a flexible and modular support framework for pipes, cables, and equipment.',
    products: [
      {
        id: 13,
        name: 'C SLOTTED CHANNEL',
        slug: 'c-slotted-channel',
        image: '/img/products/c-slotted-channel.png',
        appImage: '/img/products/c-slotted-channel-app.png', 
        description:
          'Used for adjustable structural support and mounting in construction and manufacturing, including hanging cable trays, ducting, and pipes',
        material: 'Galvanized Steel',
        thickness: '1.5mm & 2mm',
        length: '2.5m',
        finish: 'Pre-Galvanized',
      },
      {
        id: 14,
        name: 'UNISTRUT CHANNEL',
        slug: 'unistrut-channel',
        image: '/img/products/unistrut-channel.png',
        appImage: '/img/products/unistrut-channel-app.png',
        description:
          'Used to create robust and adjustable support structures in a wide range of industrial and construction applications',
        material: 'Galvanized Steel',
        finish: 'Pre-Galvanized / Hot Dip Galvanized',
      },
    ],
  },

  'electrical-accessories': {
    description:
      'A wide range of essential electrical accessories engineered for safety, durability, and seamless integration in electrical installations.',
    products: [
      {
        id: 17,
        name: 'PVC CABLE CLIP',
        slug: 'pvc-cable-clip',
        image: '/img/products/pvc-cable-clip.png',
        appImage: '/img/products/pvc-cable-clip-app.jpg', 
        description:
          'Used for cable management and are ideal for securing various cables and wires to surfaces like walls, ceilings, and floors',
        material: 'PVC with Hardened Steel Nail',
        size: '6mm - 25mm',
      },
      {
        id: 18,
        name: 'WOODEN PLUG',
        slug: 'wooden-plug',
        image: '/img/products/wooden-plug.png',
        appImage: '/img/products/wooden-plug-app.png',
        description:
          'Used to fill screw holes for a smooth finish, reinforce joints, and conceal fasteners',
        material: 'Natural Wood',
        size: 'NO 8 - NO 14',
        quantity: '20 - 30 nos/packet',
      },
      {
        id: 19,
        name: 'METAL FAN HOOK BOX',
        slug: 'metal-fan-hook-box',
        image: '/img/products/metal-fan-hook-box.png',
        appImage: '/img/products/metal-fan-hook-box-app.png',
        description:
          'Used to provide secure mounting and electrical connections for a ceiling fan or other heavy light fixture',
        material: 'Galvanized Iron',
        finish: 'Powder Coated',
        shape: 'Circle / Hexagon',
      },
      {
        id: 20,
        name: 'METAL MODULAR BOX',
        slug: 'metal-modular-box',
        image: '/img/products/metal-modular-box.png',
        appImage: '/img/products/metal-modular-box-app.png',
        description:
          'Protects electrical components like switches and circuit breakers. Ensures safety by preventing accidental contact and protecting against dust and moisture. Provides a modular, organized setup for easy installation and maintenance.',
        material: 'Galvanized Iron',
        finish: 'Zinc Plated / Powder Coated',
      },
      {
        id: 35,
        name: 'CFL CLAMP',
        slug: 'cfl-clamp',
        image: '/img/products/cfl-clamp.png',
        appImage: '/img/products/cfl-clamp-app.png',
        description:
          'Used to support CFL bulbs in light fixtures, mount street lights or other outdoor lights, and securely hold bulbs in place during installation.',
        material: 'Galvanized Steel',
        finish: 'Zinc Plated',
      },
      {
        id: 36,
        name: 'LED DOOM CLAMP',
        slug: 'led-doom-clamp',
        image: '/img/products/led-doom-clamp.png',
        appImage: '/img/products/led-doom-clamp-app.png',
        description:
          'Used to securely hold LED bulbs or tubes in light fixtures, ensure proper alignment and electrical contact, protect the LEDs from displacement or vibrations, and simplify installation and maintenance.',
        material: 'Galvanized Steel',
        finish: 'Zinc Plated',
      },
    ],
  },

  'cable-management': {
    description:
      'Complete cable management solutions that keep wiring organized, protected, and easy to maintain across residential, commercial, and industrial installations.',
    products: [
      {
        id: 21,
        name: 'PERFORATED CABLE TRAY',
        slug: 'perforated-cable-tray',
        image: '/img/products/perforated-cable-tray.png',
        appImage: '/img/products/perforated-cable-tray-app.jpg', 
        description:
          'Used in industrial facilities, data centers, commercial buildings, and telecommunications infrastructure due to their strong ventilation, heat management, and organized cable support',
        material: 'Galvanized Steel / Stainless Steel',
        finish: 'Pre-Galvanized / Powder Coated',
      },
      {
        id: 22,
        name: 'RACEWAY CABLE TRAY',
        slug: 'raceway-cable-tray',
        image: '/img/products/raceway-cable-tray.png',
        appImage: '/img/products/raceway-cable-tray-app.png',
        description:
          'Commercial, industrial, and datacenter installations for organizing, protecting, and supporting electrical and data cables',
        material: 'Galvanized Steel',
        finish: 'Pre-Galvanized / Powder Coated',
      },
      {
        id: 23,
        name: 'LADDER TYPE CABLE TRAY',
        slug: 'ladder-type-cable-tray',
        image: '/img/products/ladder-type-cable-tray.png',
        appImage: '/img/products/ladder-type-cable-tray-app.png',
        description:
          'Industrial and large-scale facilities for heavy power distribution, telecommunications, and control systems due to their robust structure, excellent ventilation, and easy cable access for maintenance and upgrades',
        material: 'Galvanized Steel',
        finish: 'Pre-Galvanized / Hot Dip Galvanized',
      },
      {
        id: 24,
        name: 'WIRE MESH CABLE TRAY',
        slug: 'wire-mesh-cable-tray',
        image: '/img/products/wire-mesh-cable-tray.png',
        appImage: '/img/products/wire-mesh-cable-tray-app.png',
        description:
          'Used in data centers, healthcare, transportation, industrial facilities, and renewable energy projects to organize and support cables for lighting, security, power, and communication systems',
        material: 'Galvanized Steel / Stainless Steel',
        finish: 'Electro-Zinc Plated / Powder Coated',
      },
    ],
  },

  fasteners: {
    description:
      'Quality fasteners designed for secure fixing, offering consistent strength, precise fit, and dependable performance across multiple applications.',
    products: [
      {
        id: 25,
        name: 'THREADED RODS',
        slug: 'threaded-rods',
        image: '/img/products/threaded-rods.png',
        appImage: '/img/products/threaded-rods-app.png',
        description:
          'Used for supporting and anchoring pipes.especially in corrosive environments.',
        material: 'Carbon Steel / Stainless Steel',
        grade: 'M8, M10, M12',
        length: '2m',
      },
      {
        id: 26,
        name: 'BULLET FASTENER',
        slug: 'bullet-fastener',
        image: '/img/products/bullet-fastener.png',
        appImage: '/img/products/bullet-fastener-app.png',
        description:
          'A bullet fastener is used to fix rods or brackets into concrete ceilings or walls. It is hammered into a drilled hole, and when the rod is tightened, it expands to hold firmly in place. Commonly used for suspending clamps, electrical trays, or pipes in building construction.',
        material: 'Carbon Steel',
        grade: 'M8, M10, M12',
        finish: 'Zinc Plated',
      },
      {
        id: 27,
        name: 'ANCHOR BOLT',
        slug: 'anchor-bolt',
        image: '/img/products/anchor-bolt.png',
        appImage: '/img/products/anchor-bolt-app.png',
        description:
          'It is used to securely attach objects or structures to concrete or masonry surfaces. It is inserted into a drilled hole, and when tightened, it expands to hold firmly in place. Commonly used in fixing pipes, machinery, beams, or heavy equipment to floors and walls.',
        material: 'Carbon Steel',
        size: '50mm, 60mm, 72mm',
        grade: 'M8, M10',
        finish: 'Zinc Plated',
      },
      {
        id: 28,
        name: 'ALL TYPE SCREWS',
        slug: 'all-type-screws',
        image: '/img/products/all-type-screws.png',
        appImage: '/img/products/all-type-screws-app.jpg', 
        description:
          'Used as fasteners to hold or join materials together. They provide secure, stable, and removable connections in wood, metal, or plastic.',
        material: 'Carbon Steel / Stainless Steel',
        finish: 'Zinc Plated / Black Phosphate',
      },
      {
        id: 37,
        name: 'CONCRETE NAIL',
        slug: 'concrete-nail',
        image: '/img/products/concrete-nail.png',
        appImage: '/img/products/concrete-nail-app.png',
        description:
          'Attaching materials like wood and metal to concrete, brick, and other hard substrates.',
        material: 'Hardened Steel',
        size: '1" - 4"',
        quantity: '1 kg/box',
      },
      {
        id: 38,
        name: 'ANCHOR BOLT (SS304)',
        slug: 'anchor-bolt-ss304',
        image: '/img/products/anchor-bolt-ss304.png',
        appImage: '/img/products/anchor-bolt-ss304-app.png',
        description:
          'It is used to securely attach objects or structures to concrete or masonry surfaces. It is inserted into a drilled hole, and when tightened, it expands to hold firmly in place. Commonly used in fixing pipes, machinery, beams, or heavy equipment to floors and walls.',
        material: 'Stainless Steel (SS304)',
        size: 'M8x50, M10x50, M10x75',
        grade: 'SS304',
      },
      {
        id: 39,
        name: 'COACH SCREW',
        slug: 'coach-screw',
        image: '/img/products/coach-screw.png',
        appImage: '/img/products/coach-screw-app.png',
        description:
          'Used to attach pipe supports and hangers to wooden structures/metal.',
        material: 'Carbon Steel',
        size: '38x8mm, 50x8mm',
        quantity: '150 nos/box',
        finish: 'Zinc Plated',
      },
    ],
  },
};

// Helper functions
export const getProductsByCategory = (categorySlug) => {
  return CATEGORIES_PRODUCTS[categorySlug]?.products || [];
};

export const getCategoryDescription = (categorySlug) => {
  return CATEGORIES_PRODUCTS[categorySlug]?.description || '';
};

export const getProductBySlug = (productSlug, categorySlug = null) => {
  if (categorySlug) {
    const products = getProductsByCategory(categorySlug);
    return products.find((product) => product.slug === productSlug);
  }

  // Search across all categories
  for (const cat in CATEGORIES_PRODUCTS) {
    const product = CATEGORIES_PRODUCTS[cat].products.find(
      (p) => p.slug === productSlug
    );
    if (product) return { ...product, categorySlug: cat };
  }
  return null;
};

export const getProductRoute = (productSlug) => {
  return `/products/${productSlug}`;
};

// Get all products from all categories
export const getAllProducts = () => {
  const allProducts = [];
  for (const cat in CATEGORIES_PRODUCTS) {
    const products = CATEGORIES_PRODUCTS[cat].products.map((product) => ({
      ...product,
      categorySlug: cat,
    }));
    allProducts.push(...products);
  }
  return allProducts;
};

export const getCategoryRoute = (categorySlug) => {
  return `/products/${categorySlug}`;
};

// Legacy export for backward compatibility
export const CATEGORY_DATA = CATEGORIES_PRODUCTS;
